// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heading {
  position: relative;
}
@media screen and (min-width: 495px) {
  .heading {
    padding: 0 40px;
  }
}
.heading h2.headline {
  font-size: 32px;
  line-height: 38px;
  font-weight: 600;
  text-align: center;
  color: #ffffff;
  position: relative;
  margin: 0;
  margin-top: 30px;
}
@media screen and (min-width: 495px) {
  .heading h2.headline {
    font-size: 48px;
    line-height: 72px;
    text-align: left;
  }
}
.heading .line {
  display: none;
  position: absolute;
  background-color: #f8f8f8;
  width: 100%;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0 auto;
  height: 1px;
}
@media screen and (min-width: 495px) {
  .heading .line {
    display: block;
  }
}
.heading .attribute .button {
  float: right;
} `, "",{"version":3,"sources":["webpack://./src/components/Headline/headline.scss","webpack://./src/components/Headline/headline.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;ACCF;ADAE;EAFF;IAGI,eAAA;ECGF;AACF;ADDE;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;ACGJ;ADFI;EATF;IAUI,eAAA;IACA,iBAAA;IACA,gBAAA;ECKJ;AACF;ADFE;EACE,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,cAAA;EACA,WAAA;ACIJ;ADHI;EAVF;IAWI,cAAA;ECMJ;AACF;ADFI;EACE,YAAA;ACIN","sourcesContent":[".heading {\n  position: relative;\n  @media screen and (min-width: 495px) {\n    padding: 0 40px;\n  }\n\n  h2.headline {\n    font-size: 32px;\n    line-height: 38px;\n    font-weight: 600;\n    text-align: center;\n    color: #ffffff;\n    position: relative;\n    margin: 0;\n    margin-top: 30px;\n    @media screen and (min-width: 495px) {\n      font-size: 48px;\n      line-height: 72px;\n      text-align: left;\n    }\n  }\n\n  .line {\n    display: none;\n    position: absolute;\n    background-color: #f8f8f8;\n    width: 100%;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    margin: 0 auto;\n    height: 1px;\n    @media screen and (min-width: 495px) {\n      display: block;\n    }\n  }\n\n  .attribute {\n    .button {\n      float: right;\n    }\n  }\n}\n",".heading {\n  position: relative;\n}\n@media screen and (min-width: 495px) {\n  .heading {\n    padding: 0 40px;\n  }\n}\n.heading h2.headline {\n  font-size: 32px;\n  line-height: 38px;\n  font-weight: 600;\n  text-align: center;\n  color: #ffffff;\n  position: relative;\n  margin: 0;\n  margin-top: 30px;\n}\n@media screen and (min-width: 495px) {\n  .heading h2.headline {\n    font-size: 48px;\n    line-height: 72px;\n    text-align: left;\n  }\n}\n.heading .line {\n  display: none;\n  position: absolute;\n  background-color: #f8f8f8;\n  width: 100%;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: 0 auto;\n  height: 1px;\n}\n@media screen and (min-width: 495px) {\n  .heading .line {\n    display: block;\n  }\n}\n.heading .attribute .button {\n  float: right;\n} /*# sourceMappingURL=headline.css.map */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
